export enum ProfileEventsVersionsEnum {
  '1.0.0' = '1.0.0',
}
export default ProfileEventsVersionsEnum;
